<template>
  <div>
    <!-- <div class="modal fade crenew-session-popuop add-speaker">
      <div class="modal-dialog add_addendee-popup">
        <div class="modal-content" style="position: relative">
      
          <div class="register_popup">
            <div class="modal-header">
              <h4 class="modal-title page-head">Add new attendee</h4>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
          </div>

         
          <div class="modal-body py-0">
            <div class="ss-cns-body-wrap">
              <h5 class="my-4"><strong>Basic Info</strong></h5>
             
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>First Name*</label>
                    <input
                      type="Text"
                      class="form-control ss-cns-name"
                      placeholder="First Name"
                      v-model="Attendee.FirstName"
                    />
                  </div>
                  <div>
                    <label>Last Name</label>
                    <input
                      type="Text"
                      class="form-control ss-cns-name"
                      placeholder="Last Name"
                      v-model="Attendee.LastName"
                    />
                  </div>
                  <div class="form-group">
                    <label>Email*</label>
                    <input
                      type="Text"
                      class="form-control"
                      placeholder="Enter Email"
                      v-model="Attendee.Email"
                    />
                  </div>
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input
                      type="Text"
                      class="form-control"
                      placeholder="Enter Phone Number"
                      v-model="Attendee.Phone"
                    />
                  </div>
                  <hr />
                </div>
                <div class="col-md-6 ss-add-imgbox-wrap text-center">
                  <div class="ss-add-imgbox mx-auto">
                    <img
                      v-if="Attendee.ProfilePictureURL"
                      :src="Attendee.ProfilePictureURL"
                      alt="e2m"
                    />
                    <img v-else src="../assets/Images/avatar.jpg" alt="e2m" />
                  </div>
                  <p>
                    JPG or PNG no larger than 1MB.<br />Square image looks the
                    best
                  </p>
                  <div class="custom--inputfile-btn-hld">
                    <input
                      type="file"
                      class="custom--inputfile"
                      @change="update_avatar"
                      accept="image/*"
                    />
                    <button type="button" class="btn btn-default">
                      Choose File
                    </button>
                  </div>
                </div>
              </div>
            

              <h5 class="my-4"><strong>Others Info (Optional)</strong></h5>
              <div class="row">
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Organization</label>
                    <input
                      type="Text"
                      v-model="Attendee.Company"
                      class="form-control"
                      placeholder="Organization Name"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Job Title</label>
                    <input
                      type="Text"
                      v-model="Attendee.Designation"
                      class="form-control"
                      placeholder="Add Job Title"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Website</label>
                    <input
                      type="Text"
                      v-model="Attendee.Website"
                      class="form-control"
                      placeholder="Organization Name"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Country</label>
                    <select v-model="Attendee.Country" class="form-control">
                      <option value="">Select</option>
                      <option
                        v-for="country in CountryList"
                        :key="country"
                        :value="country"
                      >
                        {{ country }}
                      </option>
               
                    </select>
                  </div>
                </div>
                <div class="col-md-12 py-0">
                  <div class="form-group mb-0">
                    <label>Enter Search Keywords</label>
                    <textarea
                      type="Text"
                      class="form-control"
                      cols="5"
                      placeholder="Add multiple Keywords separated by comma.eg:marketing,branding,techonology"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="col-md-12 py-0">
                  <label>Short Bio</label>
                  <textarea type="Text" class="form-control" placeholder="">
                  </textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer ss-cns-foo-btn">
            <button
              type="button"
              class="btn btn-default px-8"
              data-dismiss="modal"
            >
              Cancel
            </button>
  
            <v-btn
              :loading="IsSubmitting"
              class="btn btn-primary px-8"
              @click="SaveAttendee"
              color="#1973e7"
            >
              Save
            </v-btn>
          </div>
        </div>
     
      </div>
    </div> -->

    <v-dialog v-if="Attendee" v-model="Attendee" max-width="1024" scrollable>
      <v-card class="attendee-add-wrap-mod">
        <div style="position: absolute; right: 15px; top: 15px">
          <v-icon
            style="z-index: 2"
            size="32"
            @click="
              cropImageUrl = null;
              Attendee = null;
            "
            >close</v-icon
          >
        </div>
        <v-card-title v-if="Attendee && Attendee.AttendeeId == undefined">
          <h5>Add new attendee</h5>
        </v-card-title>
        <v-card-title v-else class="text-h5"> Update attendee </v-card-title>

        <v-card-text>
          <div class="ss-cns-body-wrap" v-if="cropImageUrl == null">
            <h5 class="my-4"><strong>Basic Info</strong></h5>
            <!--top area start-->
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>First Name*</label>
                  <input
                    type="Text"
                    class="form-control ss-cns-name"
                    placeholder="First Name"
                    v-model="Attendee.FirstName"
                    id="firstNameAttendee"
                  />
                </div>
                <div class="form-group">
                  <label>Last Name</label>
                  <input
                    type="Text"
                    class="form-control ss-cns-name"
                    placeholder="Last Name"
                    v-model="Attendee.LastName"
                  />
                </div>
                <div class="form-group">
                  <label>Email*</label>
                  <input
                    type="Text"
                    class="form-control"
                    placeholder="Enter Email"
                    v-model="Attendee.Email"
                  />
                </div>
                <div class="form-group">
                  <label>Phone Number</label>
                  <input
                    type="Text"
                    class="form-control"
                    placeholder="Enter Phone Number"
                    v-model="Attendee.Phone"
                  />
                </div>
                <hr />
              </div>
              <div class="col-md-6 ss-add-imgbox-wrap text-center">
                <div class="ss-add-imgbox mx-auto">
                  <img
                    v-if="Attendee.ProfilePictureURL"
                    :src="Attendee.ProfilePictureURL"
                    alt="e2m"
                  />
                  <img
                    v-else
                    src="../assets/Images/reg-ico/default-profile-pic.svg"
                    alt="e2m"
                  />
                </div>
                <p>
                  JPG or PNG 200x200 px or 1:1 ratio<br />no larger than
                  10MB.<br />Square image looks the best
                </p>
                <div class="custom--inputfile-btn-hld">
                  <input
                    type="file"
                    class="custom--inputfile"
                    @change="update_avatar"
                    accept="image/*"
                  />
                  <button type="button" class="btn btn-default">
                    Choose File
                  </button>
                </div>
              </div>
            </div>
            <!--top area end-->

            <h5 class="my-4"><strong>Others Info (Optional)</strong></h5>
            <div class="row">
              <div class="col-md-6 pb-0">
                <div class="form-group">
                  <label>Organization</label>
                  <input
                    type="Text"
                    v-model="Attendee.Company"
                    class="form-control"
                    placeholder="Organization Name"
                  />
                </div>
              </div>
              <div class="col-md-6 pb-0">
                <div class="form-group">
                  <label>Job Title</label>
                  <input
                    type="Text"
                    v-model="Attendee.Designation"
                    class="form-control"
                    placeholder="Add Job Title"
                  />
                </div>
              </div>
              <div class="col-md-6 py-0">
                <div class="form-group">
                  <label>Website</label>
                  <input
                    type="Text"
                    v-model="Attendee.Website"
                    class="form-control"
                    placeholder="Website URL"
                  />
                </div>
              </div>
              <div class="col-md-6 py-0">
                <div class="form-group">
                  <label>Country-{{Attendee.Country}}</label>
                  <select v-model="Attendee.Country" class="form-control">
                    <option value="">Select</option>
                    <option
                      v-for="country in CountryList"
                      :key="country"
                      :value="country"
                    >
                      {{ country }}
                    </option>
                    <!-- <option>A</option>
                      <option>b</option> -->
                  </select>
                </div>
              </div>
              <div class="col-md-12 py-0">
                <div class="form-group mb-0">
                  <label>Enter Search Keywords</label>
                  <!-- <textarea
                    type="Text"
                    class="form-control"
                    cols="5"
                    placeholder="Add multiple Keywords separated by comma.eg:marketing,branding,techonology"
                    v-model="Attendee.Tags"
                  >
                  </textarea> -->
                  <input-tag
                    tabindex="9"
                    id="txtTags"
                    class="w-full mt-4 form-control"
                    placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology"
                    v-model="Attendee.Tags"
                    name="Tags"
                  ></input-tag>
                </div>
              </div>
              <div class="col-md-12 py-0 form-group">
                <label>Short Bio</label>
                <textarea type="Text" class="form-control" placeholder="" v-model="Attendee.Profile">
                </textarea>
              </div>
            </div>
          </div>
          <div class="ss-cns-body-wrap" v-else>
            <h5 class="my-4">
              <strong
                ><v-icon
                  @click="cropImageUrl = null"
                  size="30"
                  color="black"
                  class="mr-2 cursor-pointer"
                  >mdi-arrow-left</v-icon
                >Aspect Ratio for this image is {{ displayImageRatio }}. To crop
                this image, simply drag and click Upload</strong
              >
            </h5>

            <cropper
              :key="resetCropper"
              v-bind:aspectValue="imageRatio"
              :sourceImage="cropImageUrl"
              :file="imageFileDetails"
              :uploadPath="folderImageUploadPath"
              :clientId="clientId"
              :eventId="eventId"
              @uploadedImagePath="uploadedImagePath"
            />
          </div>
        </v-card-text>

        <v-divider class="m-0" v-if="cropImageUrl == null"></v-divider>
        <v-card-actions v-if="cropImageUrl == null">
          <div class="full-width text-left text-md-right py-2 final-button">
            <v-btn
              color="#1c1d26"
              large
              class="mr-2 cancel-standard"
              outlined
              width="100px"
              @click="
                cropImageUrl = null;
                Attendee = null;
              "
            >
              Cancel
            </v-btn>

            <v-btn
              :loading="IsSubmitting"
              dark
              color="#2376e5"
              large
              class="save-standard"
              @click="SaveAttendee"
              width="100px"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-if="cropImageUrl"
      v-model="cropImageUrl"
      max-width="950"
      style="z-index: 999999"
    >
      <v-card>
        <div style="position: absolute; right: 10px; top: 15px">
          <v-icon style="z-index: 2" size="32" @click="cropImageUrl = null"
            >close</v-icon
          >
        </div>
        <v-card-title class="text-h5"> Image Cropper </v-card-title>
        <v-card-text>
          <div
            id="profileCropper"
            class=""
            title="Crop Image"
            style="z-index: 99999"
          >
            <h5>
              Aspect Ratio for this image is {{ displayImageRatio }}. To crop
              this image, simply drag and click Upload
            </h5>
            <cropper
              :key="resetCropper"
              v-bind:aspectValue="imageRatio"
              :sourceImage="cropImageUrl"
              @croppedImagePath="croppedImagePath"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import Cropper from "../components/CropperComponent.vue";
import InputTag from "vue-input-tag";
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import { bus } from "@/main";

let vm;
export default {
  name: "attendee",
  components: {
    Cropper,
    InputTag,
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    event_collectionName: {
      type: String,
      default: "",
    },
    Attendee: {
      type: Object,
      default: () => ({
        Name: "",
        FirstName: "",
        LastName: "",
        Email: "",
        //Password: randomNumber,
        Tags: "",
        Phone: "",
        Country: "",
        FormType: "FREE",
        RegistrationType: {
          ColorCode: "",
          RegistrationType: "Attendee",
          RegistrationTypeId: "",
        },
        Company: "",
        Designation: "",
        Profile: "",
        ProfilePictureURL: "",
        Website: "",
        SocialLinks: [],
      }),
    },
  },
  data() {
    return {
      imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      IsSubmitting: false,
      CountryList: [],
      uploadedFile: null,
      imageFileDetails: null,
      folderImageUploadPath: null,
    };
  },
  watch: {},
  mounted() {
    if (!this.Attendee) {
      this.Attendee = {
        Name: "",
        FirstName: "",
        LastName: "",
        Email: "",
        //Password: randomNumber,
        Tags: "",
        Phone: "",
        Country: "",
        FormType: "FREE",
        RegistrationType: {
          ColorCode: "",
          RegistrationType: "Attendee",
          RegistrationTypeId: "",
        },
        Company: "",
        Designation: "",
        Profile: "",
        ProfilePictureURL: "",
        Website: "",
        SocialLinks: [],
      };
    }

    setTimeout(() => {
      document.getElementById("firstNameAttendee").focus();
    }, 500);

    vm = this;
    vm.CountryList = common.getCountryList();
  },
  beforeDestroy() {},
  methods: {
    uploadedImagePath(data) {
      if (data && data.Status == 200) {
        vm.cropImageUrl = null;
        vm.imageFileDetails = null;
        vm.folderImageUploadPath = null;
        vm.Attendee.ProfilePictureURL = data.Path;
      } else {
        alert("fail");
      }
    },
    SaveAttendee() {
      
      
      bus.$emit("toggleLoader", true);
      if (!vm.Attendee.FirstName) {
        vm.showSnackbar("First Name is mandatory", "error", "top");
        bus.$emit("toggleLoader", false);
        return;
      } else if (!vm.Attendee.Email) {
        vm.showSnackbar("Email is mandatory", "error", "top");
        bus.$emit("toggleLoader", false);
        return;
      } else if (!vm.isValidEmail(vm.Attendee.Email)) {
        vm.showSnackbar("Email is not valid", "error", "top");
        bus.$emit("toggleLoader", false);
        return;
      } else {
        var attendee = {};
        if (vm.Attendee.AttendeeId) {
          vm.IsSubmitting = true;



          attendee = {
            UserId: vm.Attendee.AttendeeId,
            Name:
              vm.Attendee.FirstName.trim() + " " + vm.Attendee.LastName.trim(),
            FirstName: vm.Attendee.FirstName.trim(),
            LastName: vm.Attendee.LastName.trim(),
            Email: vm.Attendee.Email.toLowerCase().trim(),
            AttendeeId: vm.Attendee.AttendeeId ? vm.Attendee.AttendeeId : null,
            Phone: vm.Attendee.Phone,
            Country: vm.Attendee.Country ? vm.Attendee.Country : "",
            FormType: vm.Attendee.FormType ? vm.Attendee.FormType : "FREE",
            RegistrationType: vm.Attendee.RegistrationType
              ? vm.Attendee.RegistrationType
              : {
                  ColorCode: "",
                  RegistrationType: "Attendee",
                  RegistrationTypeId: "",
                },
            Company: vm.Attendee.Company,
            Designation: vm.Attendee.Designation,
            Profile: vm.Attendee.Profile,
            ProfilePictureURL: vm.Attendee.ProfilePictureURL
              ? vm.Attendee.ProfilePictureURL
              : "",
            Website: vm.Attendee.Website,
            SocialLinks: [
              { Facebook: "" },
              { GooglePlus: "" },
              { LinkedIn: "" },
              { Twitter: "" },
            ],
            Tags: vm.Attendee.Tags ? vm.Attendee.Tags : "",
            MailSent: false,
            IsVerified: true,
            IsPublished: true,
            UserRoles: [
              {
                RoleID: 10,
                RoleName: "AppUser",
              },
            ],
          };

          let headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + vm.getSessionToken(),
          };
          let requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: vm.clientId,
              eventId: vm.eventId,
            },
            data: attendee,
          };
          axios
            .post(APIs.UpdateSingleAttendee, requestData, {
              headers: headers,
            })
            .then(function (res) {
              bus.$emit("toggleLoader", false);
              vm.IsSubmitting = false;
              debugger;
              if (res.status == 200) {
                vm.$emit("OnUpdateAttendeeSuccess");
              } else {
                vm.showSnackbar("Something went wrong", "error", "top");
              }
            })
            .catch(function (error) {
              bus.$emit("toggleLoader", false);
              vm.IsSubmitting = false;
              vm.showSnackbar("Something went wrong", "error", "top");
              console.log("Error adding attendee:", error);
            });
        } else {
          var postData = {
            key: {
              instanceId: "OA_UAT",
              clientId: vm.clientId,
              eventId: vm.eventId,
            },
            data: {
              Email: vm.Attendee.Email,
            },
          };
          //self.showLoader();

          let headers = {
            "Content-Type": "application/json",
            "x-api-key": APIs.XAPIkey,
          };
          axios
            .post(APIs.CheckUserStatus, JSON.stringify(postData), {
              headers: headers,
            })
            .then((response) => {
              if (response.data.attendeeStatus) {
                vm.showSnackbar("Email already exist", "error", "top");
                bus.$emit("toggleLoader", false);
                return true;
              } else {
                attendee = {
                  Name:
                    vm.Attendee.FirstName.trim() +
                    " " +
                    vm.Attendee.LastName.trim(),
                  FirstName: vm.Attendee.FirstName.trim(),
                  LastName: vm.Attendee.LastName.trim(),
                  Email: vm.Attendee.Email.toLowerCase().trim(),
                  AttendeeId: vm.Attendee.AttendeeId
                    ? vm.Attendee.AttendeeId
                    : null,
                  Phone: vm.Attendee.Phone,
                  Country: vm.Attendee.Country ? vm.Attendee.Country : "",
                  FormType: vm.Attendee.FormType
                    ? vm.Attendee.FormType
                    : "FREE",
                  RegistrationType: vm.Attendee.RegistrationType
                    ? vm.Attendee.RegistrationType
                    : {
                        ColorCode: "",
                        RegistrationType: "Attendee",
                        RegistrationTypeId: "",
                      },
                  Company: vm.Attendee.Company,
                  Designation: vm.Attendee.Designation,
                  Profile: vm.Attendee.Profile,
                  ProfilePictureURL: vm.Attendee.ProfilePictureURL
                    ? vm.Attendee.ProfilePictureURL
                    : "",
                  Website: vm.Attendee.Website,
                  SocialLinks: [
                    { Facebook: "" },
                    { GooglePlus: "" },
                    { LinkedIn: "" },
                    { Twitter: "" },
                  ],
                  Tags: vm.Attendee.Tags ? vm.Attendee.Tags : "",
                  MailSent: false,
                  IsVerified: true,
                  IsPublished: true,
                  UserRoles: [
                    {
                      RoleID: 10,
                      RoleName: "AppUser",
                    },
                  ],
                };
                let headers = {
                  "Content-Type": "application/json",
                  "x-api-key": APIs.DeleteAttendeeApiKey,
                };
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: vm.clientId,
                    eventId: vm.eventId,
                  },
                  data: attendee,
                  sendMail: 0,
                };
                axios
                  .post(APIs.AddSingleAttendee, requestData, {
                    headers: headers,
                  })
                  .then(function (res) {
                    vm.IsSubmitting = false;
                    bus.$emit("toggleLoader", false);
                    debugger;
                    if (res.status == 200) {
                      vm.$emit("OnAddAttendeeSuccess");
                      bus.$emit("toggleLoader", false);
                    } else {
                      vm.showSnackbar("Something went wrong", "error", "top");
                    }
                  })
                  .catch(function (error) {
                    bus.$emit("toggleLoader", false);
                    vm.IsSubmitting = false;
                    vm.showSnackbar("Something went wrong", "error", "top");
                    console.log("Error adding attendee:", error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
              bus.$emit("toggleLoader", false);
            });
        }
      }
    },
    update_avatar(input) {
      //console.log(checkRatio);
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // You can update avatar Here
      bus.$emit("toggleLoader", true);
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

         const fileSize = file.size / 1024 / 1024;
          if (fileSize > 10) {
            bus.$emit("toggleLoader", false);
            alert("File size exceeds 10 MB");
            return;
          }


        console.log(metadata);
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        // let dimension = fileWH.split("x");

        // console.log(dimension);
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.imageFileDetails = file;
            vm.folderImageUploadPath = obj.eventcollectionname + "/Attendees/";
            bus.$emit("toggleLoader", false);
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.session_data.SessionLogo = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$vs.loading.close();
          // this.$vs.notify({
          //   color: "warning",
          //   position: "top-center",
          //   //title: "Session",
          //   text: "Something went wrong!",
          // });
        });
    },
  },
};
</script>
